<template>
  <div>
    <v-card
      v-show="$vuetify.breakpoint.mdAndUp"
      color="white"
      style="width: calc(100vw - 526px)"
      :loading="loadingDetail"
    >
      <v-card-text style="height: calc(100vh - 96px)">
        <v-container bg fill-height text-xs-center class="pr-0">
          <v-row
            align="center"
            justify="center"
            v-if="getPublicacionSeleccionada === null"
          >
            <v-col v-if="!this.getError.error">
              <p class="text-center overline">
                Selecciona un elemento en el panel izquierdo para comenzar
              </p>
            </v-col>
            <v-col
              class="d-flex justify-center align-center flex-column"
              v-else
            >
              <v-icon size="90" color="red" class="mb-4"
                >mdi-lan-disconnect</v-icon
              >
              <p class="subtitle-2" style="color: red">
                Un error ha ocurrido, intenta recargando la página.
              </p>
            </v-col>
          </v-row>
          <v-container v-else style="height: 100%; overflow-y: auto" fluid>
            <v-row>
              <v-col cols="12" sm="12">
                <v-layout>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      class="d-flex justify-center text-h4 font-weight-bold"
                    >
                      {{ getSelectedPublicacion.titulo }}
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      class="d-flex justify-center text-h6 font-weight-light"
                    >
                      <div class="d-flex">
                        <img
                          class="mx-4"
                          style="max-height: 90px"
                          :src="
                            getSelectedPublicacion.usuarioUNI.fotoPerfil
                              ? getSelectedPublicacion.usuarioUNI.fotoPerfil
                              : getStaticProfile
                          "
                        />
                        <div
                          class="
                            d-flex
                            flex-column
                            justify-center
                            font-weight-medium
                          "
                        >
                          <div>
                            {{ getSelectedPublicacion.usuarioUNI.nombres }}
                            {{
                              getSelectedPublicacion.usuarioUNI.apellidoPaterno
                            }}
                            {{
                              getSelectedPublicacion.usuarioUNI.apellidoMaterno
                            }}
                          </div>
                          <div
                            class="font-weight-light"
                            v-if="getSelectedPublicacion.usuarioUNI.carrera"
                          >
                            Especialidad de
                            {{
                              getSelectedPublicacion.usuarioUNI.carrera
                                .nombreEspecialidad
                            }}
                          </div>
                          <div class="text--disabled text-body-1">
                            Código UNI
                            {{ getSelectedPublicacion.usuarioUNI.codigoUNI }}
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      class="
                        d-flex
                        justify-center
                        align-center
                        text-body-1
                        font-weight-light
                      "
                      >Palabras Clave:
                      <template
                        v-if="getSelectedPublicacion.palabrasClave.length"
                      >
                        <v-chip
                          class="mx-1 font-weight-bold"
                          small
                          v-for="(
                            chip, index
                          ) in getSelectedPublicacion.palabrasClave"
                          :key="index"
                          >{{ chip }}</v-chip
                        >
                      </template>
                      <template v-else
                        ><p class="mb-0 text--disabled">
                          No Especificado
                        </p></template
                      >
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-container class="d-flex flex-column">
                        <div class="font-weight-bold text-h4">Resumen</div>
                        <div class="font-weight-light text-h6" v-html="getSelectedPublicacion.resumenPublicacion">
                        </div>
                      </v-container>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      v-if="getSelectedPublicacion.linkReferencia"
                      class="d-flex justify-center"
                    >
                      <v-btn
                        color="indigo"
                        dark
                        block
                        :href="getSelectedPublicacion.linkReferencia"
                        target="_blank"
                        ><v-icon left>mdi-file-search</v-icon>Link de
                        Referencia</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-layout>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      itemListSelected: {},
      loadingDetail: false
    };
  },

  computed: {
    ...mapGetters('user', [
      'getError',
      'fetching',
      'getPublicacionSeleccionada',
      'getListaPublicaciones'
    ]),

    getSelectedPublicacion () {
      if (this.getListaPublicaciones.length) {
        return this.getListaPublicaciones[this.getPublicacionSeleccionada];
      }
      return {};
    },

    getStaticProfile () {
      return require('@/assets/anonymous.png');
    }
  }
};
</script>

<style scoped>
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(245, 245, 245, 0.15);
}

::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(245, 245, 245, 0.308);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: rgba(85, 85, 85, 0.5);
}
</style>
